import { render, staticRenderFns } from "./4.vue?vue&type=template&id=eba9c36a&scoped=true&"
var script = {}
import style0 from "./4.vue?vue&type=style&index=0&id=eba9c36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba9c36a",
  null
  
)

export default component.exports